export default {
    actionButtonSize: 56,
    // https://material.google.com/layout/metrics-keylines.html#metrics-keylines-touch-target-size
    iconSize: 24,
    avatarSize: 40,
    snackbarHeight: 48,
};



// WEBPACK FOOTER //
// ./node_modules/react-native-material-ui/src/styles/spacing.js